import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=3f2ba578&scoped=true"
import script from "./TaskIndex.vue?vue&type=script&lang=js"
export * from "./TaskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ba578",
  null
  
)

export default component.exports